import { OverlayContainer } from "@angular/cdk/overlay";

export class OverlayOverrideContainer extends OverlayContainer {
	protected override _createContainer(): void {
		const container: HTMLDivElement = document.createElement("div");
		container.classList.add("app-overlay-container");

		const overlayComponent: Element | undefined | null = document.querySelector("tenora-overlay-container");

		const shadowRoot: Element | undefined | null =
			overlayComponent?.shadowRoot?.querySelector("#overlay-container");
		if (shadowRoot !== undefined && shadowRoot !== null) {
			shadowRoot.appendChild(container);
			this._containerElement = container;
		}
	}
}
